/**
 * @method generateHash
 * @param {BookLocation} bookLocation - book location to use to generate hash
 * @returns {String} url location hash string with leading #
 */
const generateHash = (bookLocation) => {
  // Determine the best query parameter to use for position within the document.
  if (bookLocation.cfi !== undefined) {
    return `#${bookLocation.cfi}`;
  }

  if (bookLocation.element !== undefined) {
    return `##${bookLocation.element}`;
  }

  if (bookLocation.percentageOfDocument !== undefined) {
    return `#${bookLocation.percentageOfDocument * 100}%`;
  }

  if (bookLocation.wordOffset !== undefined) {
    return `#word${bookLocation.wordOffset[0]}-${bookLocation.wordOffset[1]}`;
  }

  return '';
};

export default generateHash;
